import { PageHeader } from '../components/PageHeader';
import { toolConnectors } from '../lib/seedData';

export function ToolLibraryPage() {
  return (
    <section className="page">
      <PageHeader title="Tool connector library" description="Connector inventory with risk, auth type, and evidence requirements." />
      <div className="card table-wrap">
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Type</th>
              <th>Auth</th>
              <th>Risk</th>
              <th>Setup</th>
              <th>Endpoint</th>
            </tr>
          </thead>
          <tbody>
            {toolConnectors.map((tool) => (
              <tr key={tool.id}>
                <td>{tool.name}</td>
                <td>{tool.type}</td>
                <td>{tool.authType}</td>
                <td><span className={`badge ${tool.riskLevel}`}>{tool.riskLevel}</span></td>
                <td>{tool.setupDifficulty}</td>
                <td>{tool.endpoint}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
